
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import {
    getUserProductRankList
  } from '@/api/statistic';
  import PageFooter from '@/components/page-footer.vue';

  @Component({
    name: 'product-rank',
    components: {
      PageFooter,
    }
  })
  export default class ProductRank extends Vue {
    private id = +this.$route.query.id;
    private list: any = [];
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;

    private mounted() {
      this.getList();
    }

    private changeCurrent(e: any) {
      this.pageNo = e;
      this.getList();
    }

    private async getList() {
      try {
        const res: any = await getUserProductRankList({
          product_id: this.id,
          page_no: this.pageNo,
          page_size: this.pageSize
        })
        this.total = res.count;
        this.list = res.info || []
      } catch (e) {
        console.log(e);
      }
    }
  }
